import React, { Component } from 'react';
import ReactTable from 'react-table';
import { Checkbox, Form } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { caseInsensitiveFilter } from 'Common/GridHelper';
import EditableLabel from 'Components/editableLabel/EditableLabel';
import { UpdateBidDetailsEnum } from 'Common/FieldEnum';
import { TabDisabledInput } from 'Common/FormHelper';
import { dateSortMethod, numericSortMethod } from 'Common/GridHelper';

class BidDetailsInfo extends Component {
  static propTypes = {
    dataSource: PropTypes.array.isRequired,
    loadingBidDetails: PropTypes.bool,
    sorted: PropTypes.array,
    filtered: PropTypes.array,
    onSortedChange: PropTypes.func,
    onFilteredChange: PropTypes.func,
  };
  static defaultProps = {
    loadingBidDetails: false,
    sorted: [],
    filtered: [],
    onSortedChange: () => {},
    onFilteredChange: () => {},
  };
  columns = [
    {
      Header: () => {
        const { dataSource } = this.props;
        const check =
          dataSource.length === this.getCheckedItemsLength() &&
          dataSource.length > 0;
        return (
          <Checkbox
            style={{ marginTop: 10 }}
            checked={check}
            tabIndex={-1}
            onClick={(e, data) => {
              this.handleHeaderLevelCheckBox(data.checked);
            }}
          />
        );
      },
      Cell: ({ original }) => {
        return (
          <div style={{ textAlign: 'center' }}>
            <Checkbox
              checked={this.getCheckedItem(original)}
              tabIndex={-1}
              onClick={(e, data) => {
                this.updateBidDetailsInfo(original, data.checked);
              }}
            />
          </div>
        );
      },
      sortable: false,
      filterable: false,
    },
    {
      Header: 'Item Code',
      accessor: UpdateBidDetailsEnum.ItemCode,
    },
    {
      Header: 'Description',
      accessor: UpdateBidDetailsEnum.Description,
    },
    {
      Header: () => {
        return (
          <span>
            Bid Price
            <br />
            End Date
          </span>
        );
      },
      accessor: UpdateBidDetailsEnum.ItemBidPriceEndDate,
      sortMethod: dateSortMethod,
    },
    {
      Header: 'Bid Price',
      accessor: UpdateBidDetailsEnum.PrimaryPrice,
      className: 'right-align',
      sortMethod: numericSortMethod,
    },
    {
      Header: 'New Bid Price',
      accessor: UpdateBidDetailsEnum.NewPrimaryPrice,
      Cell: ({ original }) => {
        return (
          <EditableLabel
            label={
              original[UpdateBidDetailsEnum.NewPrimaryPrice]
                ? original[UpdateBidDetailsEnum.NewPrimaryPrice]
                : ''
            }
            labelClassName={'qtyLabel'}
            refData={original}
            inputType={'text'}
            onChange={this.handleChangeBidPrice}
            disabled={this.props.disabled}
            allowEdit={true}
          />
        );
      },
      Filter: TabDisabledInput,
      sortable: false,
    },
  ];
  getCheckedItemsLength = () => {
    const len = _.filter(this.props.input.value, item => {
      return item[UpdateBidDetailsEnum.checked];
    }).length;
    return len;
  };

  getCheckedItem = original => {
    const {
      input: { value },
    } = this.props;
    const inputRow = _.find(value, item => {
      return (
        item[UpdateBidDetailsEnum.ItemId] ===
        original[UpdateBidDetailsEnum.ItemId]
      );
    });
    return inputRow && inputRow[UpdateBidDetailsEnum.checked];
  };
  handleHeaderLevelCheckBox = checked => {
    let dataSourceCopy =
      this.props.dataSource && this.props.dataSource.length
        ? _.cloneDeep(this.props.dataSource)
        : [];
    const { input } = this.props;
    if (dataSourceCopy.length && input.value && input.value.length) {
      _.each(input.value, row => {
        const index = _.findIndex(dataSourceCopy, item => {
          return (
            item[UpdateBidDetailsEnum.ItemId] ===
            row[UpdateBidDetailsEnum.ItemId]
          );
        });

        if (index > -1) {
          dataSourceCopy[index] = { ...row };
        }
      });
    }
    dataSourceCopy = dataSourceCopy.map(item => {
      item.checked = checked;
      return item;
    });
    this.props.input.onChange(dataSourceCopy);
  };

  updateBidDetailsInfo = (original, checked) => {
    const formValues =
      this.props.input.value && this.props.input.value.length
        ? _.cloneDeep(this.props.input.value)
        : [];
    const index = _.findIndex(formValues, formValue => {
      return (
        formValue[UpdateBidDetailsEnum.ItemId] ===
        original[UpdateBidDetailsEnum.ItemId]
      );
    });
    if (index > -1) {
      formValues[index][UpdateBidDetailsEnum.checked] = checked;
    } else {
      const newFiled = { ...original };
      newFiled[UpdateBidDetailsEnum.checked] = checked;
      formValues.push(newFiled);
    }
    this.props.input.onChange(formValues);
  };

  handleChangeBidPrice = (refData, newValue) => {
    newValue = newValue.match(/\d{0,6}(\.\d{0,4})?/)[0];
    const formValues =
      this.props.input.value && this.props.input.value.length
        ? _.cloneDeep(this.props.input.value)
        : [];
    const index = _.findIndex(formValues, formValue => {
      return (
        formValue[UpdateBidDetailsEnum.ItemId] ===
        refData[UpdateBidDetailsEnum.ItemId]
      );
    });
    if (index > -1) {
      formValues[index][UpdateBidDetailsEnum.NewPrimaryPrice] = newValue;
    } else {
      const newFiled = Object.assign({}, refData);
      newFiled[UpdateBidDetailsEnum.NewPrimaryPrice] = newValue;
      formValues.push(newFiled);
    }
    this.props.input.onChange(formValues);
  };

  prepareTableData = () => {
    const dataSourceCopy =
      this.props.dataSource && this.props.dataSource.length
        ? _.cloneDeep(this.props.dataSource)
        : [];
    const { value } = this.props.input;
    if (value && value.length && dataSourceCopy && dataSourceCopy.length) {
      _.each(value, item => {
        const index = _.findIndex(dataSourceCopy, {
          [UpdateBidDetailsEnum.ItemId]: item[UpdateBidDetailsEnum.ItemId],
        });
        if (index > -1) {
          const dataRow = { ...item };
          dataSourceCopy[index][UpdateBidDetailsEnum.NewPrimaryPrice] =
            dataRow[UpdateBidDetailsEnum.NewPrimaryPrice];
        }
      });
    }
    return dataSourceCopy;
  };

  render() {
    const {
      loadingBidDetails,
      sorted,
      filtered,
      onSortedChange,
      onFilteredChange,
    } = this.props;
    return (
      <Form.Field>
        <ReactTable
          minRows={0}
          loading={loadingBidDetails}
          data={this.prepareTableData()}
          resizable={true}
          sortable={true}
          filterable={true}
          className={'-striped -highlight'}
          defaultFilterMethod={caseInsensitiveFilter}
          noDataText={loadingBidDetails ? '' : 'No items found'}
          loadingText={loadingBidDetails ? 'Loading...' : ''}
          columns={this.columns}
          sorted={sorted}
          filtered={filtered}
          onSortedChange={onSortedChange}
          onFilteredChange={onFilteredChange}
        />
      </Form.Field>
    );
  }
}
export default BidDetailsInfo;



// WEBPACK FOOTER //
// ./src/pages/utilities/updatebiddetails/containers/BidDetailsInfo.js